import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M11.5 4C10.083 4 9 5 9 6.167v5.666C9 13 10.083 14 11.5 14s2.5-1 2.5-2.167V6.167C14 5 12.917 4 11.5 4"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M17 10v.833c0 1.547-.58 3.031-1.61 4.125-1.032 1.094-2.431 1.709-3.89 1.709s-2.858-.615-3.89-1.709C6.58 13.864 6 12.38 6 10.833V10m5.5 7v2.75M8.357 20h6.286"
    }, null, -1)
  ])))
}
export default { render: render }